import { render, staticRenderFns } from "./EventsTable.vue?vue&type=template&id=0e321045&scoped=true&"
import script from "./EventsTable.vue?vue&type=script&lang=js&"
export * from "./EventsTable.vue?vue&type=script&lang=js&"
import style0 from "./EventsTable.vue?vue&type=style&index=0&id=0e321045&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e321045",
  null
  
)

export default component.exports